import { useTranslation } from 'react-i18next';
import { NoteReceivable } from '../../generated/graphql';
import { AmountTable, AmountTableProps } from './Table';

interface NotesReceivableTableContainerProps
  extends Pick<
    AmountTableProps,
    'title' | 'className' | 'hideOnEmpty' | 'isLoading' | 'tableRowsContainerClassName' | 'tableTitleClassName'
  > {
  noteReceivableArray?: NoteReceivable[];
  onItemClicked?: (a: { noteReceivable: NoteReceivable }) => void;
  children?: (p: { noteReceivable: NoteReceivable }) => React.ReactNode;
}

export const NotesReceivableTableContainer = ({
  children,
  onItemClicked,
  noteReceivableArray,
  ...props
}: NotesReceivableTableContainerProps) => {
  const { t: tCommon } = useTranslation('common');

  return (
    <AmountTable hideOnEmpty={props.hideOnEmpty ?? true} title={props.title ?? tCommon('notes-receivable')} {...props}>
      {noteReceivableArray
        ?.sort((a, b) => a.name.localeCompare(b.name))
        .map((noteReceivable) => children?.({ noteReceivable }))}
    </AmountTable>
  );
};
